import { TmrBaseResource } from 'stylewhere/api'

export class Checklist extends TmrBaseResource {
  static endpoint = 'api/v1/checklists' //logistics
}
